export default __webpack_public_path__ + "static/media/PwC.f2b6ce02.png";